module.exports = __webpack_public_path__ + "img/portraits_09_V.ab2f0121.webp";